export enum TYPES {
  ACTION_DEFAULT = '@@calendario/ACTION_DEFAULT',

  DEFAULT_SAGA = '@@calendario/DEFAULT_SAGA'
}

export interface CALENDARIO {
  defaultValue: string
}
